module.exports = __webpack_public_path__ + "static/img/rewards.dd312d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/rewards.png
// module id = Jnn1
// module chunks = 1